module.exports = __webpack_public_path__ + "img/parigi-1.f8249da2.jpg";